import type { ImageData } from '../types/pdf.types';

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, value));

export const getPageNumberAtPosition = (
  container: HTMLDivElement | null,
  visiblePages: Set<number>,
  mouseY: number,
): number => {
  const pageElements = container?.querySelectorAll('[data-page-number]');
  if (!pageElements) return Array.from(visiblePages)[0] || 1;

  for (const el of Array.from(pageElements)) {
    const rect = el.getBoundingClientRect();
    if (mouseY >= rect.top && mouseY <= rect.bottom) {
      return parseInt(el.getAttribute('data-page-number') || '1');
    }
  }
  return Array.from(visiblePages)[0] || 1;
};

export const createDocumentOptions = (pdfjsVersion: string) => ({
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjsVersion}/cmaps/`,
  cMapPacked: true,
});

export const triggerBrowserDownload = (
  pdfBytes: Uint8Array,
  filename = 'edited-form.pdf',
) => {
  // eslint-disable-next-line no-undef
  const blob = new Blob([pdfBytes as BlobPart], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const createPastedImageData = ({
  container,
  visiblePages,
  mouseY,
  mouseX,
  imageUrl,
  width,
  height,
  scale,
}: {
  container: HTMLDivElement | null;
  visiblePages: Set<number>;
  mouseY: number;
  mouseX: number;
  imageUrl: string;
  width: number;
  height: number;
  scale: number;
}): ImageData => {
  const pageNumber = getPageNumberAtPosition(container, visiblePages, mouseY);

  let relativeX = 100 * scale;
  let relativeY = 100 * scale;

  if (container) {
    const containerRect = container.getBoundingClientRect();
    relativeX = mouseX - containerRect.left;
    relativeY = mouseY - containerRect.top;

    const pageElement = container.querySelector(
      `[data-page-number="${pageNumber}"]`,
    );
    if (pageElement) {
      const pageRect = pageElement.getBoundingClientRect();
      relativeX = Math.max(0, mouseX - pageRect.left);
      relativeY = Math.max(0, mouseY - pageRect.top);

      relativeX = Math.min(relativeX, pageRect.width - 50);
      relativeY = Math.min(relativeY, pageRect.height - 50);
    }
  }

  return {
    id: `img-${Date.now()}`,
    url: imageUrl,
    position: {
      x: relativeX / scale,
      y: relativeY / scale,
    },
    size: {
      width: Math.min(width, 300) / scale,
      height: Math.min(height, 300) / scale,
    },
    pageNumber,
  };
};
